export default "__VITE_ASSET__Du$$WfGq__"